import { useState } from "react";
import { faqs } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[360px_1fr] lg:gap-14">
          <Reveal>
            <div className="lg:sticky lg:top-28">
              <span className="inline-flex items-center gap-2 rounded-md bg-primary-100 px-2.5 py-1 text-xs font-medium text-primary-700">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-question-line" aria-hidden="true" />
                </span>
                先把疑问解决
              </span>
              <h2 className="font-heading mt-4 text-2xl font-bold leading-tight text-foreground-950 md:text-3xl">
                关于内部入口，
                <br />
                你可能想先确认这几件事
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                我们把读者问得最多的问题放在最显眼的位置。答案直给，不绕弯，也不用注册才能看。
              </p>
              <div className="mt-6 rounded-lg border border-secondary-200 bg-secondary-50 p-4">
                <p className="text-xs leading-relaxed text-secondary-900">
                  仍有疑问？可在页面底部留下邮箱，我们按每天两次的节奏统一回复。
                </p>
              </div>
            </div>
          </Reveal>

          <div className="divide-y divide-background-300/60 border-y border-background-300/60">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <Reveal key={faq.q} delay={index * 45}>
                  <div>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center gap-4 py-5 text-left"
                    >
                      <span className="font-heading text-sm tabular-nums text-background-500">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <span
                        className={`font-heading flex-1 text-base font-semibold transition-colors md:text-lg ${
                          isOpen ? "text-primary-700" : "text-foreground-950"
                        }`}
                      >
                        {faq.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md border transition-colors ${
                          isOpen
                            ? "border-primary-300 bg-primary-100 text-primary-700"
                            : "border-background-300 text-foreground-500"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true" />
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="pb-5 pl-0 pr-10 text-sm leading-relaxed text-foreground-600 md:pl-9">
                          {faq.a}
                        </p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}